import { Injectable } from '@angular/core';
import { SessionTimeOutModelContent } from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  AccountRecoveryAem,
  AuxiliaryNavigationAemItem,
  HeaderFooterMachCore,
  SignupLoginAem
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { LoginFacadeHelperSupportService } from './login-facade-helper-support.service';
@Injectable({
  providedIn: 'root'
})
export class LoginFacadeHelperService extends LoginFacadeHelperSupportService {
  assignSignupDetails(item: AuxiliaryNavigationAemItem): void {
    const signupItem = item as SignupLoginAem;
    this.tooltipSignUpContent = signupItem.signupTooltipLabel
      ? signupItem.signupTooltipLabel
      : this.tooltipSignUpContent;
    this.assignSignupDetailsHelper(signupItem);
  }

  assignSignupDetailsHelper(item: SignupLoginAem): void {
    this.signupLabel = item.rightnavLabel ? item.rightnavLabel : '';
    this.signupLink = item.rightnavLink ? item.rightnavLink : '';
  }

  assignAccountRecoveryToolTipValues(item: AccountRecoveryAem): void {
    this.tooltipAccountRecoveryContent.label = item.accountRecoveryToolTipLabel
      ? item.accountRecoveryToolTipLabel
      : '';
    this.tooltipAccountRecoveryContent.header =
      item.accountRecoveryToolTipHeader
        ? item.accountRecoveryToolTipHeader
        : '';
  }

  assignAccountRecoveryDetails(item: AuxiliaryNavigationAemItem): void {
    const recoveryItem = item as AccountRecoveryAem;
    this.tooltipAccountRecoveryContent.linkLabel =
      recoveryItem.accountRecoveryLink ? recoveryItem.accountRecoveryLink : '';
    this.tooltipAccountRecoveryContent.link =
      recoveryItem.accountRecoveryNavLink
        ? recoveryItem.accountRecoveryNavLink
        : '';
    this.assignAccountRecoveryToolTipValues(recoveryItem);
    this.assignAccountRecoveryDetailsHelper(recoveryItem);
  }

  assignAccountRecoveryDetailsHelper(item: AccountRecoveryAem): void {
    this.hideAccountRecoveryTooltip =
      item.hideAccountRecoveryTooltip === 'true';
    this.mfaToolTipDisplayPages = item.mfaToolTipDisplayPages
      ? item.mfaToolTipDisplayPages
      : [];
  }

  checkItemInList(key: string, data: HeaderFooterMachCore): void {
    if (key === 'login' || key === 'signup' || key === 'accountrecovery') {
      this.pushValue(key, data);
    }
  }

  pushValue(key: string, data: HeaderFooterMachCore): void {
    const loggedInMilesLabel = data.header.auxiliaryNavigation.find(
      (item) => item.id === key
    );
    if (loggedInMilesLabel) {
      this.loginArr.push(loggedInMilesLabel);
    }
  }

  updateSessionTimeoutContent(
    partialUpdate: Partial<SessionTimeOutModelContent>
  ): void {
    this.sessionTimeOutContent$.next({
      ...this.sessionTimeOutContent$.getValue(),
      ...partialUpdate
    });
  }

  refreshSessionOnExtend(): void {
    this.getUserSessionDetails();
    this.showSessionTimeoutModal = false;
  }
}
